interface useReorderProps {
  rows: Array<any>
  setRows: Function
  sortRowsUrl: string
  sortableProperty: string
  reorderRows: Function
}

const sortByAlphabet = (props: useReorderProps) => {
  const originalOrder = [...props.rows]
  const reOrdered = props.rows.sort(function (a, b) {
    return a[props.sortableProperty].localeCompare(b[props.sortableProperty])
  })
  reOrdered.forEach((elm: any, i) => {
    elm.order = i++
  })
  props.setRows(reOrdered)
  props
    .reorderRows({
      sortRowsUrl: props.sortRowsUrl,
      data: reOrdered,
    })
    .then((result: boolean) => {
      if (!result) {
        originalOrder.forEach((elm: any, i) => {
          elm.order = i++
        })
        props.setRows(originalOrder)
      }
    })
}

export default sortByAlphabet
